module.exports = ".edit-payments-table > tbody > tr > td:first-child {\n  padding-left: 0 !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/settings/quote-invoice-templates/qt-templates-update/qt-fixed-template-control/qt-fixed-template-control.component.scss
// module id = ./web/modern/components/settings/quote-invoice-templates/qt-templates-update/qt-fixed-template-control/qt-fixed-template-control.component.scss
// module chunks = 0